import { useCallback } from 'react';
import { useCarousel } from './useCarousel';
export function useNext() {
  var carousel = useCarousel();
  return useCallback(function () {
    carousel.slideTo(carousel.currentIndex + 1);
  }, []);
}